module.exports = __webpack_public_path__ + "static/img/M-615-EBANO.c7e9c0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-615-EBANO.png
// module id = QBCX
// module chunks = 0